<template>
    <SWysiwyg
        :name="fieldName"
        :input-data="text"
        :namespace="namespace"
        :key="namespace"
    />
</template>

<script>
import PopulationBoilerplate from '@/views/Admin/Config/Population/Fields/PopulationBoilerplate';
import SWysiwyg from '@/views/Common/Input/SWysiwyg';

export default {
    components: { SWysiwyg },
    mixins: [ PopulationBoilerplate ],
    data() {
        return {
            text: '',
        };
    },

    methods: {
        loadFieldData() {
            if (this.population) {
                this.text = this.population.text;
            }

            this.setFieldData();
        },

        setFieldData() {
            this.fieldData = {
                text: this.text,
            };

            this.storeFieldData();
        }
    },
};
</script>
